export { AddDataModal } from "./AddDataModal";
